@if (toasts.length) {
<div class="fixed top-4 left-0 right-0 z-[10000] flex flex-col gap-2 pointer-events-none">
  @for (t of toasts; track t.id) {
  <div class="w-full flex" [ngClass]="getItemPositionClass(t.position)">
    <div class="max-w-xl w-auto mx-4 pointer-events-auto">
      <div [ngClass]="getToastColor(t.type)"
        class="flex items-center min-w-fit max-w-full min-h-[56px] p-4 text-gray-500 divide-gray-200 rounded-[16px] shadow-lg gap-4 animate-in fade-in slide-in-from-top-2 duration-300">
        <span class="flex-shrink-0 flex items-center justify-center w-6 h-6">
          <i [class]="t.icon" class="leading-none flex"></i>
        </span>
        <span class="whitespace-pre-line break-words text-text-primary text-[14px] font-medium leading-5">
          {{ t.message }}
        </span>
        <button (click)="removeToast(t.id)"
          class="flex items-center justify-center p-1 hover:bg-black/5 rounded-full transition-colors"
          title="Cerrar">
          <i class="fi fi-rr-cross text-[10px]"></i>
        </button>
      </div>
    </div>
  </div>
  }
</div>
}
